import _ from 'lodash';
import React, { useMemo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

const orderList = (a: any, b: any) => {
  if (a.orderIndex == null && b.orderIndex == null) {
    // No sort when no OrderIndex
    return 0;
  }
  // Order First OrderIndex than Name
  if (a.orderIndex === b.orderIndex && a.value) {
    return a.value.localeCompare(b.value);
  }
  return a.orderIndex - b.orderIndex;
};

export const MultChoiceMultSelect: React.FC<React.PropsWithChildren<any>> = ({
  field,
  form: { errors, setFieldValue, submitCount, setFieldTouched },
  question,
  choices = [],
  isEditing,
  required,
  meta,
}) => {
  const { t } = useTranslation(['translation']);
  const errorMustBeDisplayed = useMemo(() => meta.touched || submitCount > 0, [submitCount, meta.touched]);

  const computedOptions = choices.flatMap((item: any) => {
    return { value: item.id, orderIndex: item.orderIndex, label: item.name };
  });
  const sortedOptions = useMemo(() => [...computedOptions].sort((a, b) => orderList(a, b)), [computedOptions]);
  const isInvalid = meta.touched && meta.error;
  return (
    <Form.Group controlId={`validation_${field.name}`} className={required ? 'form-group required' : 'form-group'}>
      {question !== undefined && (
        <Form.Label className={required ? 'fw-bold' : ''}>
          {question} {required ? ' *' : ''}
        </Form.Label>
      )}

      <Row>
        <Col style={{ minWidth: '90px' }}>
          <Form.Control type="hidden" isInvalid={_.get(errors, field.name) && errorMustBeDisplayed} />

          <Select
            {..._.omit(field, 'onBlur', 'handleBlur')}
            value={field.value ? field.value.map((id: string) => sortedOptions.find((c: any) => c.value === id)) : []}
            isMulti
            closeMenuOnSelect={false}
            options={sortedOptions}
            className="multi-select"
            classNamePrefix={isInvalid ? 'is-invalid' : ''}
            placeholder="Select..."
            isDisabled={isEditing === false}
            onChange={(selectedOptions) => {
              setFieldTouched(field.name, true);
              setFieldValue(field.name, selectedOptions ? selectedOptions.map((op: any) => op.value) : []);
            }}
            getOptionLabel={(op) => t(op.label)}
            getOptionValue={(op) => op.value}
            onBlur={() => setFieldTouched(field.name, true)}
          />
          {errorMustBeDisplayed && <Form.Control.Feedback type="invalid">{_.get(errors, field.name, '')}</Form.Control.Feedback>}
        </Col>
      </Row>
    </Form.Group>
  );
};
